import CryptoJS from "crypto-js";

const SECRET_KEY = "trustspike@123";

// Encryption function
export const encryptData = (data) => {
    if (!data) return null;

    const secretKey = process.env.REACT_APP_SECRET_KEY;
    if (!secretKey) throw new Error("Secret key not defined");

    return CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_SECRET_KEY).toString();
};

// Decryption function
export const decryptData = (ciphertext) => {
    if (!ciphertext) return null;

    const secretKey = SECRET_KEY;
    if (!secretKey) throw new Error("Secret key not defined");

    const bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(decryptedData);
};
